import { render, staticRenderFns } from "./RollWithdraw.vue?vue&type=template&id=0bbcd9bd&scoped=true"
import script from "./RollWithdraw.vue?vue&type=script&lang=js"
export * from "./RollWithdraw.vue?vue&type=script&lang=js"
import style0 from "./RollWithdraw.vue?vue&type=style&index=0&id=0bbcd9bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbcd9bd",
  null
  
)

export default component.exports